import React, { memo } from 'react';
import ProductCardStatic from 'components/consumer/ProductCardStatic';
import addDomainToPath from 'commons/addDomainToPath';

/**
 * Adapter component for New Consumer App (NextJS)
 * Uses Algolia data for immediate rendering without GraphQL calls
 */
const SearchProductCardAdapterNewConsumerApp = memo(({ hit, position }) => {
  const productId = parseInt(hit.product_id || hit.objectID, 10);
  const slugOrId = hit.slug ?? hit.objectID ?? productId;
  const pathSegment =
    hit.url_key && String(hit.url_key) !== 'null'
      ? hit.url_key
      : slugOrId != null && String(slugOrId) !== 'null'
      ? `/products/${slugOrId}`
      : null;

  // Use Algolia data for immediate rendering
  const productData = {
    id: productId,
    name: hit.name || '',
    slug: slugOrId != null ? String(slugOrId) : undefined,
    path:
      pathSegment == null
        ? undefined
        : pathSegment.startsWith('/')
        ? pathSegment
        : `/${pathSegment}`,
    productFamily: hit.family || '',
    productType: hit.type || '',
    productLabel: 'Trending',
    variantsToShow: [
      {
        id: `${hit.product_id || hit.objectID}-default`,
        image: hit.small_img ? addDomainToPath(hit.small_img) : null,
        price: hit.price ? Math.round(hit.price * 0.6) : 0,
        originalPrice: hit.price || 0,
        path:
          pathSegment == null
            ? undefined
            : pathSegment.startsWith('/')
            ? pathSegment
            : `/${pathSegment}`,
        quickship: false,
        isOutOfStock: false,
        sku: hit.serial_number || hit.objectID,
      },
    ],
    variantsTotal: 1,
    position: position || 1,
    layout: 'minimal',
    analyticsComponentName: 'search-product-card',
  };

  return <ProductCardStatic {...productData} />;
});

SearchProductCardAdapterNewConsumerApp.displayName =
  'SearchProductCardAdapterNewConsumerApp';

export default SearchProductCardAdapterNewConsumerApp;
